// German, non-blaming messages for Better Auth error codes shown in the auth forms.
const messages: Record<string, string> = {
  INVALID_EMAIL_OR_PASSWORD:
    "E-Mail oder Passwort stimmen nicht. Prüf die Eingabe und versuch es nochmal.",
  USER_ALREADY_EXISTS:
    "Mit dieser E-Mail gibt es schon ein Konto. Melde dich einfach an.",
  USER_ALREADY_EXISTS_USE_ANOTHER_EMAIL:
    "Mit dieser E-Mail gibt es schon ein Konto. Melde dich einfach an.",
  // Thrown by the allowlist check in src/server/auth.ts (sign-up and login).
  EMAIL_NOT_ALLOWED:
    "Diese E-Mail-Adresse ist für das Kochbuch nicht freigeschaltet. Frag bitte nach, ob sie freigeschaltet werden kann.",
  INVALID_EMAIL:"Diese E-Mail-Adresse sieht nicht vollständig aus.",
  PASSWORD_TOO_SHORT: "Das Passwort braucht mindestens 8 Zeichen.",
  PASSWORD_TOO_LONG: "Das Passwort ist zu lang.",
  // Password reset link expired or already used.
  INVALID_TOKEN:
    "Dieser Link gilt nicht mehr. Fordere unter „Passwort vergessen?“ einfach einen neuen an.",
}

// Better Auth's rate limiter (src/server/auth.ts) answers with HTTP 429 and no error code.
const TOO_MANY_REQUESTS =
  "Das waren zu viele Versuche in kurzer Zeit. Warte bitte ein paar Minuten und versuch es dann nochmal."

export function authErrorMessage(
  error: { code?: string; message?: string; status?: number } | null | undefined,
  fallback = "Das hat gerade nicht geklappt. Versuch es bitte nochmal."
): string {
  if (error?.status === 429) return TOO_MANY_REQUESTS
  return (error?.code && messages[error.code]) || fallback
}
